import * as React from 'react';
import 'classnames';
import Chevron$1 from '../assets/icons/Chevron.esm.js';

var Chevron = function (_a) {
    var isClickable = _a.isClickable, onClick = _a.onClick, direction = _a.direction;
    var ChevronComponent = React.createElement(Chevron$1, { direction: direction, isEnabled: isClickable });
    var wrapInClickableDiv = function (children) { return (React.createElement("div", { className: "nv-pagination-clickable-icon", onClick: onClick, onKeyDown: function (e) { return (e.key === 'Enter' ? onClick() : null); }, role: "button", tabIndex: 0 }, children)); };
    return isClickable ? wrapInClickableDiv(ChevronComponent) : ChevronComponent;
};

export { Chevron };
//# sourceMappingURL=Chevron.esm.js.map
